export enum PERMISSION_ROLE_KEYS {
  ROLE_EXTERNAL = 'EXTERNAL_TASK',
}
